/*
 * Copyright (c) 2024 Cozy Intellect Inc.
 */

import { writable } from 'svelte/store';

const skipScroll = writable(false);

const pathname = writable('');

export { pathname, skipScroll };
